import { ChainId } from '@donaswap/sdk'

export const SHOULD_SHOW_ALERT = {
  [ChainId.FIRECHAIN]: true,
  [ChainId.RINIA]: true,
  [ChainId.FIRECHAIN_ZKEVM]: true,
  [ChainId.FIRECHAIN_ZKEVM_GHOSTRIDER]: true,
  [ChainId.ETHEREUM]: true,
  [ChainId.GOERLI]: true,
  [ChainId.SEPOLIA]: true,
  [ChainId.HOLESKY]: true,
  [ChainId.BSC]: true,
  [ChainId.BSC_TESTNET]: true,
  [ChainId.POLYGON]: true,
  [ChainId.POLYGON_AMOY]: true,
  [ChainId.POLYGON_ZKEVM]: true,
  [ChainId.POLYGON_ZKEVM_TESTNET]: true,
  [ChainId.CRO]: true,
  [ChainId.CRO_TESTNET]: true,
  [ChainId.AVALANCHE]: true,
  [ChainId.AVALANCHE_FUJI]: true,
  [ChainId.FANTOM_OPERA]: true,
  [ChainId.FANTOM_TESTNET]: true,
  [ChainId.CELO]: true,
  [ChainId.CELO_ALFAJORES]: true,
  [ChainId.OPTIMISM]: true,
  [ChainId.OPTIMISM_GOERLI]: true,
  [ChainId.ARBITRUM_ONE]: true,
  [ChainId.ARBITRUM_GOERLI]: true,
  [ChainId.SHIBARIUM]: true,
  [ChainId.SHIBARIUM_TESTNET]: true,
  [ChainId.PULSECHAIN]: true,
  [ChainId.PULSECHAIN_TESTNET]: true,
  [ChainId.XEN]: true,
  [ChainId.XEN_DEVNET]: true,
  [ChainId.HARMONY]: true,
  [ChainId.HARMONY_TESTNET]: true,
  [ChainId.COINEX]: true,
  [ChainId.COINEX_TESTNET]: true,
  [ChainId.DOGECHAIN]: true,
  [ChainId.DOGECHAIN_TESTNET]: true,
  [ChainId.ENGRAM_TESTNET]: true,
  [ChainId.ETHEREUM_CLASSIC]: true,
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: true,
  [ChainId.FUSION]: true,
  [ChainId.FUSION_TESTNET]: true,
  [ChainId.HECO]: true,
  [ChainId.HECO_TESTNET]: true,
  [ChainId.KCC]: true,
  [ChainId.KCC_TESTNET]: true,
  [ChainId.KLAYTN]: true,
  [ChainId.KLAYTN_BAOBAB]: true,
  [ChainId.OKXCHAIN]: true,
  [ChainId.OKXCHAIN_TESTNET]: true,
  [ChainId.THETHA]: true,
  [ChainId.THETHA_TESTNET]: true,
  [ChainId.ULTRON]: true,
  [ChainId.ULTRON_TESTNET]: true,
  [ChainId.MOONBEAM]: true,
  [ChainId.MOONRIVER]: true,
  [ChainId.MOONBASE_ALPHA]: true,
  [ChainId.AURORA]: true,
  [ChainId.AURORA_TESTNET]: true,
  [ChainId.BOBA]: true,
  [ChainId.BOBA_GOERLI]: true,
  [ChainId.GNOSIS]: true,
  [ChainId.GNOSIS_CHIADO]: true,
  [ChainId.METIS]: true,
  [ChainId.METIS_GOERLI]: true,
  [ChainId.TELOS]: true,
  [ChainId.TELOS_TESTNET]: true,
  [ChainId.SYSCOIN]: true,
  [ChainId.SYSCOIN_TANENBAUM]: true,
  [ChainId.IOTEX]: true,
  [ChainId.IOTEX_TESTNET]: true,
  [ChainId.SHIDEN]: true,
  [ChainId.ASTAR]: true,
  [ChainId.SHIBUNYA]: true,
  [ChainId.FUSE]: true,
  [ChainId.FUSE_SPARKNET]: true,
  [ChainId.VELAS]: true,
  [ChainId.VELAS_TESTNET]: true,
  [ChainId.REI]: true,
  [ChainId.REI_TESTNET]: true,
  [ChainId.KEKCHAIN]: true,
  [ChainId.KEKCHAIN_TESTNET]: true,
  [ChainId.TOMOCHAIN]: true,
  [ChainId.TOMOCHAIN_TESTNET]: true,
  [ChainId.THUNDERCORE]: true,
  [ChainId.THUNDERCORE_TESTNET]: true,
  [ChainId.WANCHAIN]: true,
  [ChainId.WANCHAIN_TESTNET]: true,
  [ChainId.RSK]: true,
  [ChainId.RSK_TESTNET]: true,
  [ChainId.ELASTOS]: true,
  [ChainId.ELASTOS_TESTNET]: true,
  [ChainId.CONFLUX]: true,
  [ChainId.CONFLUX_TESTNET]: true,
  [ChainId.BRISECHAIN]: true,
  [ChainId.BRISECHAIN_TESTNET]: true,
  [ChainId.MUUCHAIN]: true,
  [ChainId.MUUCHAIN_TESTNET]: true,
  [ChainId.CANTO]: true,
  [ChainId.CANTO_TESTNET]: true,
  [ChainId.OASIS_EMERALD]: true,
  [ChainId.OASIS_TESTNET]: true,
  [ChainId.VISION]: true,
  [ChainId.VISION_TESTNET]: true,
  [ChainId.STEP]: true,
  [ChainId.STEP_TESTNET]: true,
  [ChainId.METER]: true,
  [ChainId.METER_TESTNET]: true,
  [ChainId.GODWOKEN]: true,
  [ChainId.GODWOKEN_TESTNET]: true,
  [ChainId.CALLISTO]: true,
  [ChainId.CALLISTO_TESTNET]: true,
  [ChainId.EVMOS]: true,
  [ChainId.EVMOS_TESTNET]: true,
  [ChainId.ENERGY_WEB_CHAIN]: true,
  [ChainId.ENERGY_VOLTA]: true,
  [ChainId.BASE]: true,
  [ChainId.BASE_GOERLI]: true,
  [ChainId.KAVA]: true,
  [ChainId.KAVA_TESTNET]: true,
  [ChainId.CLOVER]: true,
  [ChainId.CLOVER_TESTNET]: true,
  [ChainId.DEFICHAIN]: true,
  [ChainId.DEFICHAIN_TESTNET]: true,
  [ChainId.BRONOS]: true,
  [ChainId.BRONOS_TESTNET]: true,
  [ChainId.FILECOIN]: true,
  [ChainId.FILECOIN_CALIBRATION]: true,
  [ChainId.FLARE]: true,
  [ChainId.FLARE_TESTNET]: true,
  [ChainId.TARAXA]: true,
  [ChainId.TARAXA_TESTNET]: true,
  [ChainId.ZKSYNC]: true,
  [ChainId.ZKSYNC_TESTNET]: true,
  [ChainId.LINEA]: true,
  [ChainId.LINEA_TESTNET]: true,
  [ChainId.BTTCHAIN]: true,
  [ChainId.BTTCHAIN_TESTNET]: true,
  [ChainId.BOBA_AVAX]: true,
  [ChainId.BOBA_BNB]: true,
  [ChainId.CMP]: true,
  [ChainId.CMP_TESTNET]: true,
  [ChainId.CORE]: true,
  [ChainId.CORE_TESTNET]: true,
  [ChainId.CUBECHAIN]: true,
  [ChainId.CUBECHAIN_TESTNET]: true,
  [ChainId.DARWINIA_CRAB]: true,
  [ChainId.DARWINIA_PANGOLIN]: true,
  [ChainId.DIODE_PRETNET]: true,
  [ChainId.DIODE_TESTNET]: true,
  [ChainId.GOCHAIN]: true,
  [ChainId.GOCHAIN_TESTNET]: true,
  [ChainId.HAQQ]: true,
  [ChainId.HAQQ_TESTEDGE2]: true,
  [ChainId.KARDIACHAIN]: true,
  [ChainId.KARDIACHAIN_TESTNET]: true,
  [ChainId.METADIUM]: true,
  [ChainId.METADIUM_TESTNET]: true,
  [ChainId.OP_BNB]: true,
  [ChainId.OP_BNB_TESTNET]: true,
  [ChainId.PALM]: true,
  [ChainId.PALM_TESTNET]: true,
  [ChainId.POLIS]: true,
  [ChainId.POLIS_TESTNET]: true,
  [ChainId.SHIBACHAIN]: true,
  [ChainId.SMART_BCH]: true,
  [ChainId.SMART_BCH_TESTNET]: true,
  [ChainId.SONGBIRD_CANARY]: true,
  [ChainId.THAICHAIN]: true,
  [ChainId.UBIQ]: true,
  [ChainId.UBIQ_TESTNET]: true,
  [ChainId.VECHAIN]: true,
  [ChainId.VECHAIN_TESTNET]: true,
  [ChainId.XINFIN]: true,
  [ChainId.XINFIN_APOTHEM]: true,
  [ChainId.SCROLL]: true,
  [ChainId.SCROLL_SEPOLIA]: true,
  [ChainId.XRPL_DEVNET]: true,
  [ChainId.ZETACHAIN]: true,
  [ChainId.ZETACHAIN_ATHENS]: true,
  [ChainId.ZYX]: true,
}

export type NetworkAlertChains = keyof typeof SHOULD_SHOW_ALERT
